import React from 'react';
import { motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-[80vh] md:min-h-screen flex flex-col items-center justify-center px-5 py-14 md:py-24 overflow-hidden" data-id="element-92">
      <div className="max-w-3xl w-full mx-auto text-center z-10" data-id="element-93">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1.2,
        ease: 'easeOut'
      }} className="space-y-5 md:space-y-8" data-id="element-94">
          <p className="text-lg md:text-2xl text-[#8b8178] font-light tracking-wide" data-id="element-95">
            At 3:17am you wake up.
          </p>

          <div className="space-y-4 md:space-y-6" data-id="element-96">
            <p className="text-xl md:text-3xl font-light leading-relaxed" data-id="element-97">
              Not wide awake. Not rested. Just…{' '}
              <span className="italic text-[#f5f0e8]" data-id="element-98">on.</span>
            </p>

            <p className="text-xl md:text-3xl font-light leading-relaxed" data-id="element-99">
              Your brain reaches for the nearest lever:
            </p>

            <h1 className="text-4xl md:text-7xl font-bold text-[#c9a96e] py-2 md:py-4 tracking-tight" data-id="element-100">
              time math.
            </h1>

            <div className="relative inline-block py-3 px-6 md:py-6 md:px-8 my-3 md:my-6" data-id="element-101">
              <span className="absolute top-0 left-0 text-3xl md:text-4xl text-[#c9a96e] opacity-40 font-serif" data-id="element-102">
                "
              </span>
              <p className="text-lg md:text-2xl italic text-[#e8e0d4] relative z-10" data-id="element-103">
                If I fall asleep in the next 20 minutes, I can still get—
              </p>
              <span className="absolute bottom-0 right-0 text-3xl md:text-4xl text-[#c9a96e] opacity-40 font-serif" data-id="element-104">
                "
              </span>
            </div>

            <p className="text-lg md:text-2xl font-light leading-relaxed" data-id="element-105">
              And right there, you feel it: the shift.
              <br data-id="element-106" />
              Your bed stops being a place you rest and turns into a place you{' '}
              <strong className="font-semibold text-[#f5f0e8]" data-id="element-107">try</strong>.
            </p>
          </div>

          <div className="pt-6 pb-4 md:pt-12 md:pb-8" data-id="element-108">
            <p className="text-xl md:text-3xl font-playfair italic text-[#c9a96e]" data-id="element-109">
              This isn't a "sleep hygiene" problem.
              <br data-id="element-110" />
              This is a <span className="font-bold not-italic" data-id="element-111">loop</span>{' '}
              problem.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.8,
        duration: 1.5
      }} className="mt-8 md:mt-12 mb-4 md:mb-8" data-id="element-112">
          <img src="https://cdn.magicpatterns.com/uploads/h4XXAbccNMmPCunxSiUww6/3AM_MOCKUP.png" alt="The 3AM Loop Breaker on a nightstand" className="w-full max-w-sm md:max-w-md mx-auto rounded-lg shadow-2xl shadow-black/50 opacity-90 hover:opacity-100 transition-opacity duration-700" data-id="element-113" />

          <motion.div initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 1.5,
          duration: 1
        }} className="mt-6 md:mt-10 text-center" data-id="element-114">
            <a href="#checkout" className="inline-block bg-[#c9a96e] hover:bg-[#d4b87a] text-[#0a0e1a] px-6 py-3 md:px-8 md:py-4 rounded-full font-bold text-base md:text-lg transition-all duration-300 shadow-[0_0_20px_rgba(201,169,110,0.3)] hover:shadow-[0_0_30px_rgba(201,169,110,0.5)]" data-id="element-115">
              Get The 3AM Loop Breaker — €6.36
            </a>
            <p className="text-[#8b8178] text-sm mt-2" data-id="element-116">
              <span className="line-through opacity-60" data-id="element-117">€28.90</span>{' '}
              <span className="text-[#c9a96e] font-semibold" data-id="element-118">78% off</span>
            </p>
          </motion.div>
        </motion.div>
      </div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 2,
      duration: 1
    }} className="absolute bottom-6 left-1/2 -translate-x-1/2 text-[#8b8178] hidden md:block" data-id="element-119">
        <ChevronDownIcon className="w-8 h-8 animate-bounce opacity-50" data-id="element-120" />
      </motion.div>

      {/* Subtle gradient overlay at bottom */}
      <div className="absolute bottom-0 left-0 w-full h-24 bg-gradient-to-t from-[#0a0e1a] to-transparent pointer-events-none" data-id="element-121" />
    </section>;
}